<template>
  <div :class="`${classes || 'col-lg-3 col-md-4 col-sm-6 bottom-offset4'}`">
    <div
      class="card center-block height-100 card--small"
      :style="cardStyle || ''"
      :class="`${cardClasses} ${cardBorder} ${onCardClick ? 'cursor-pointer' : ''}`"
      @click="onClick"
    >
      <div class="card__icon">
        <slot name="icon">
          <div>
            <img
              v-if="imageSrc"
              class="ic--medium"
              :src="imageSrc"
            >
          </div>
        </slot>
      </div>
      <div class="card__content">
        <div
          v-if="title"
          class="vertical-offset2 card__title"
        >
          <slot name="title">
            <tr-typography
              v-tooltip.top-center="title"
              classes="block"
              break-all-words="true"
              :fixed-lines-qtd="titleFixedLinesQtd"
              variant="h3"
            >
              {{ breakBiggerWordFormat(title, breakBiggerWord || 10) }}
            </tr-typography>
          </slot>
        </div>
        <div
          v-if="subtitle"
          class="vertical-offset2 card__subtitle"
        >
          <slot name="subtitle">
            <tr-typography
              classes="block"
              break-all-words="true"
            >
              {{ breakBiggerWordFormat(subtitle, breakBiggerWord || 15) }}
            </tr-typography>
          </slot>
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import TrTypography from './TrTypography.vue';
import breakBiggerWordFormat from '../formatters/breakBiggerWord';

export default {
  name: 'TrCard',
  components: {
    TrTypography
  },
  props: ['title', 'subtitle', 'imageSrc', 'onCardClick', 'cardClasses',
    'cardStyle', 'hasError', 'hasWarning', 'breakBiggerWord',
    'classes', 'titleFixedLinesQtd'],
  computed: {
    cardBorder() {
      if (this.hasError) {
        return 'card--danger';
      }
      if (this.hasWarning) {
        return 'card--warning';
      }
      return '';
    },
  },
  methods: {
    breakBiggerWordFormat,
    onClick() {
      if (this.onCardClick) {
        this.onCardClick();
      }
    }
  }
};
</script>
